import definition from './views.service';

/**
 * ViewsApi settings
 * @type {{name: string, definition: ViewsApi}}
 */
export default {
    name: 'ViewsApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/views/index.js